import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { InsuranceLogsListPage } from './InsuranceLogsListPage';

export function InsuranceLogsPage({ location, isExpanded }) {
  return (
    <Routes location={location}>
      <Route
        path="/"
        exact
        element={<InsuranceLogsListPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

InsuranceLogsPage.propTypes = {
  location: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
